import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import ModalLog from './ModalLog';
import {
  Box,
  Flex,
  HStack,
  IconButton,
  useDisclosure,
  Stack,
  useMediaQuery,
  Text,
  Container,
  Divider,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';

const NavLink = (props) => {
  const { children, to } = props;
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Box
      as={RouterLink}
      to={to}
      px={3}
      py={2}
      rounded="lg"
      fontSize="sm"
      fontWeight="semibold"
      color={isActive ? 'teal.300' : 'gray.300'}
      bg={isActive ? 'rgba(56, 178, 172, 0.1)' : 'transparent'}
      borderWidth="1px"
      borderColor={isActive ? 'teal.500' : 'transparent'}
      transition="all 0.2s"
      _hover={{
        textDecoration: 'none',
        color: 'teal.200',
        bg: 'rgba(56, 178, 172, 0.15)',
        borderColor: 'teal.400',
        transform: 'translateY(-1px)',
      }}
    >
      {children}
    </Box>
  );
};

export default function Header() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLargerThan550] = useMediaQuery('(max-width: 550px)');

  return (
    <Box 
      bg="gray.900" 
      borderBottom="1px solid"
      borderColor="gray.800"
      boxShadow="0 2px 10px rgba(0, 0, 0, 0.3)"
      position="sticky"
      top={0}
      zIndex={1000}
    >
      <Container maxW="1400px">
        <Flex h={16} alignItems="center" justifyContent="space-between">
          
          {/* Mobile Menu Button */}
          <IconButton
            size="md"
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label="Toggle Menu"
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
            bg="gray.800"
            color="teal.300"
            _hover={{ bg: 'gray.700' }}
          />

          {/* Logo/Brand */}
          <HStack spacing={8} alignItems="center" flex={1}>
            <Box
              as={RouterLink}
              to="/"
              fontWeight="bold"
              fontSize={isLargerThan550 ? 'md' : 'lg'}
              color="white"
              _hover={{ color: 'teal.300' }}
              transition="color 0.2s"
              display="flex"
              alignItems="center"
              gap={2}
            >
              <Text
                bgGradient="linear(to-r, teal.300, cyan.400)"
                bgClip="text"
                fontWeight="extrabold"
              >
                Mattias Assets
              </Text>
              <Text color="gray.500" display={{ base: 'none', lg: 'inline' }} fontSize="sm">
                Portfolio
              </Text>
            </Box>

            {/* Desktop Navigation */}
            <HStack
              as="nav"
              spacing={2}
              display={{ base: 'none', md: 'flex' }}
            >
              <NavLink to="/">🏠 Home</NavLink>
              <NavLink to="/stocks">📈 Stocks</NavLink>
              <NavLink to="/milestones">🎯 Milestones</NavLink>
              <NavLink to="/growth_tracker">🌱 Growth</NavLink>
              <NavLink to="/my_toolkit">🛠️ Toolkit</NavLink>
              <NavLink to="/about">ℹ️ About</NavLink>
            </HStack>
          </HStack>

          {/* Right Actions */}
          <Flex alignItems="center">
            <ModalLog />
          </Flex>
        </Flex>

        {/* Mobile Navigation */}
        {isOpen && (
          <Box pb={4} display={{ md: 'none' }}>
            <Divider borderColor="gray.800" mb={4} />
            <Stack as="nav" spacing={2}>
              <NavLink to="/">🏠 Home</NavLink>
              <NavLink to="/stocks">📈 Stocks & Dividends</NavLink>
              <NavLink to="/milestones">🎯 Milestones</NavLink>
              <NavLink to="/growth_tracker">🌱 Growth Tracker</NavLink>
              <NavLink to="/my_toolkit">🛠️ My Toolkit</NavLink>
              <NavLink to="/about">ℹ️ About</NavLink>
            </Stack>
          </Box>
        )}
      </Container>
    </Box>
  );
}